export enum ProtectedRoutes {
  BASE = "/",
  DASHBOARD = "/",
  CUSTOMERS = "/customers",
  ADD_CUSTOMER = "/customers/add-customer",
  EDIT_CUSTOMER = "/customers/edit-customer/:id",
  ADD_DEVICE = "/devices/add-device",
  ADD_MODEL = "/devices/add-model",
  ADD_BRAND = "/devices/add-brand",
  EDIT_DEVICE = "/devices/edit-device/:id",
  EDIT_MODEL = "/devices/edit-model/:id",
  EDIT_BRAND = "/devices/edit-brand/:id",
  PAYMENT_PLANS = "/payment-plans",
  ADD_PAYMENT_PLAN = "/payment-plans/add",
  EDIT_PAYMENT_PLAN = "/payment-plans/edit/:id",
  PAYMENT_BONUSES = "/payment-bonuses",
  ADD_PAYMENT_BONUS = "/payment-bonuses/add",
  EDIT_PAYMENT_BONUS = "/payment-bonuses/edit/:id",
  EDIT_PAYMENT_BONUS_TEMPLATE = "/payment-bonuses/edit-bonus-template/:id",
  TRANSACTIONS = "/transactions",
  TRANSACTION_DETAILS = "/transactions/:id",
  ACTIVATION_DEBUG = "/activation-debug",
  ACTIVATION_DEBUG_DETAILS = "/activation-debug/:id",
  DEVICE = "/devices",
  DEVICES = "/devices/device",
  MODELS = "/devices/model",
  BRANDS = "/devices/brand",
  SETTINGS = "/settings",
  PROFILE = "/settings/profile",
  ACCOUNT_PLANS = "/settings/account-plans",
  DONATION_NETWORKS = "/settings/donation-networks",
  MESSAGES = "/settings/messages",
  KYC = "/settings/kyc",
  DISTRUBUTORS = "/distrubutors",
  REGISTRATION_REQUEST = "/distrubutors/registration-request",
  MANAGE_DISTRUBUTORS = "/distrubutors/manage-distributors",
  DISTRUBUTORS_DETAILS = "/distrubutors/manage-distributors/:id",
  DISTRUBUTORS_REGISTER_DETAILS = "/distrubutors/registration-request/:id",
  ORDERS = "/orders",
  ORDER_DETAILS = "/orders/:id",
  PRODUCTS = "/products",
  ALL_PRODUCTS = "/products/all",
  PRODUCT_DETAILS = "/products/:id",
  ADD_PRODUCT = "/products/add",
  INVENTORY = "/inventory",
  NOT_FOUND = "*",
}

export enum PublicRoutes {
  AUTH = "/auth",
  SIGNIN = "/auth/signin",
}
